const csrfHeaderName = 'CSRF-Token';
const csrfCookieName = 'CSRF-Token';

export default (config, getState) => {
  const configUpdate = config;
  configUpdate.withCredentials = true;

  if (getState) {
    const { csrf } = getState();
    const token = csrf && csrf.token;
    if (token) {
      configUpdate.headers = { ...configUpdate.headers, [csrfHeaderName]: token };
      return configUpdate;
    }
  }

  // Fallback: let axios read from cookie when store token is not yet available
  configUpdate.xsrfCookieName = csrfCookieName;
  configUpdate.xsrfHeaderName = csrfHeaderName;
  return configUpdate;
};
